import { useEffect, useState } from "react";
import styles from "./login.module.css";

import { useDispatch, useSelector } from "react-redux";
import {
  _login_user,
  _set_pending_channel,
  _set_pending_cid,
  _set_pending_cpid,
  set_cid,
  set_cpid,
  _set_channel,
} from "../../../../store/actions/login_actions";

import { showAllErrors } from "../../../../base/utils";
import { BaseChannel } from "../../../../base/env";

import Auth from "../Auth";


import { Note } from "../../../../helbest";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "antd";
import { useMutation, useQuery } from "@apollo/client";
import { MessagingServices } from "../../../../graphql/none_saleor/otp/otp";
import { set_otp_service } from "../../../../store/actions/otp_action";
import Input from "../../../components/Input/Input";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";
import { LangLink } from "../../../components/LangLink/LangLink";
import { SendOTPMutation } from "../../../../graphql/none_saleor/auth/auth";
import { useSearchParams } from "react-router-dom";
import { countries , defaultAuthWallpaper } from "../../../../constants/countries-code";
const Login = () => {

  const [countryCode, setCountryCode] = useState(countries[0].code);
  const [loading, setLoading] = useState(false);

  const navigate = useLangNavigate();

  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const store = useSelector((state) => state);
  const {
    cid,
    cpid,
    urlCode,
    pendingChannel,
    pendingCid,
    pendingCpid,
    channel,
  } = useSelector((state) => state.Login);
  const countryCodeSelected = countries.find((i) => i.code === countryCode);
  const wallpaper = countryCodeSelected.authWallpaper || defaultAuthWallpaper;
  const effectiveCid = pendingCid || cid;

  const { refetch: getAvailableOtp } = useQuery(MessagingServices, {
    context: {
      clientName: "otp",
    },
    onError: (error) => {
      Note.error(error.message);
    },
    skip: true,
  });

  const [sendOtpMutation] = useMutation(SendOTPMutation, {
    context: {
      // headers: {
      //   "site-url": "dev.garajmall.com",
      // },
      clientName: "auth",
    },
  });

  const [searchParams] = useSearchParams();

  const platform = searchParams.get("platform");

  const submitHandler = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const { phoneNumber } = Object.fromEntries(formData.entries());

    if (!phoneNumber || phoneNumber.length < countryCodeSelected.length) {
      return Note.error(t("login.messages.mobile_invalid"));
    }
    if (!countryCode) {
      return Note.error(t("login.messages.country_code_invalid"));
    }

    setLoading(true);

    // send sms
    getAvailableOtp().then((availableResponse) => {
      if (availableResponse.data.messagingServices) {
        let messagingService = "";
        const services = availableResponse.data.messagingServices;
        if (!store.Otp?.otpService) {
          messagingService =
            services.find((service) => service.isDefault)?.value ||
            services[0].value;
          dispatch(set_otp_service(messagingService));
        } else {
          messagingService = store.Otp.otpService;
        }
        sendOtpMutation({
          variables: {
            countryCode,
            phoneNumber: phoneNumber,
            messagingService,
            cid: effectiveCid || null,
            cpid: pendingCpid || cpid,
            urlCode: urlCode || null,
            platform,
            channelSlug: pendingChannel || channel,
          },
          onCompleted: (response) => {
            setLoading(false);
            if (!response.sendOtp.errors.length) {
              dispatch(
                _login_user({
                  ...store.Login,
                  phone_number: phoneNumber,
                  countryCode: countryCode,
                }),
              );
              navigate("/verify-otp/d/", {
                state: { availableOtp: services },
              });
            } else {
              showAllErrors(response.sendOtp.errors);
              const hasCidError = response.sendOtp.errors.some(
                (err) => err.field === "cid",
              );
              if (hasCidError) {
                localStorage.removeItem("cid");
                dispatch(set_cid(""));
                dispatch(set_cpid("gmall"));
                dispatch(_set_channel(BaseChannel, channel));
                dispatch(_set_pending_channel(""));
                dispatch(_set_pending_cpid(""));
                dispatch(_set_pending_cid(""));
              }
            }
          },
        });
      }
    });
  };

  useEffect(() => {
    const foundCountry = countries.find(
      (c) => c.country.toLowerCase() === store.Region.country.toLowerCase(),
    );
    if (foundCountry) setCountryCode(foundCountry.code);
  }, [store.Region.country]);

  return (
    <Auth title={t("login.title")} wallpaper={wallpaper}>
      <form onSubmit={submitHandler} className={styles.form}>
        <div
          className={styles["phone-number-wrapper"]}
          style={{
            flexDirection: i18n.dir() === "ltr" ? "row" : "row-reverse",
          }}
        >
          <div className={styles["country-code-wrapper"]}>
            <countryCodeSelected.icon className={styles.CountryIcon} />
            <select
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              {countries.map((countryItem) => {
                return (
                  <option
                    key={countryItem.code}
                    value={countryItem.code}
                    className={styles.SelectCountryOption}
                  >
                    {countryItem.label}
                  </option>
                );
              })}
            </select>
          </div>
          <Input
            name="phoneNumber"
            maxLength={countryCodeSelected.length}
            placeholder={t("common.phone")}
            pattern="[0-9]*"
            inputMode="numeric"
            helperText={t("login.mobileNumberHelper")}
          />
        </div>
        <Button
          loading={loading}
          htmlType="submit"
          type="primary"
          size="large"
          style={{
            width: "100%",
          }}
        >
          {t("login.start_button")}
        </Button>
      </form>
      <div className={styles.policies}>
        <Trans
          i18nKey="login.reCAPTCHA"
          components={[
            <LangLink to="/terms-and-policy/">{t("login.privacy")}.</LangLink>,
            <br />,
            <LangLink to="/terms-and-policy/">
              {t("login.Terms_Service")}
            </LangLink>,
          ]}
        />
      </div>
      {/* <Drawer
        title="Need to register"
        placement="bottom"
        onClose={() => setErrorDrawer("")}
        open={errorDrawer}
        key="bottom"
        classNames={{
          content: styles.DrawerContent,
          header: styles.DrawerHeader,
        }}
        height={300}
      >
        <div className={styles.DrawerBody}>
          <span>{errorDrawer}</span>
          <IdIcon width="100px" />
          <a
            href={`tel:${errorDrawer.match(/\+?\d+/g)}`}
            className={styles.CallButton}
          >
            Call for registration
          </a>
        </div>
      </Drawer> */}
    </Auth>
  );
};

export default Login;
